import * as React        from 'react'
import classnames        from 'classnames'
import Select           from 'react-select'
import './styles.scss'

const isOptionSelected = (option: any, valueArray: any) => {
  const result = valueArray.filter((value: any) => option.value === value.value)

  if (result.length === 0) return false

  return true
}

const menuComponent = (props: any) => {
  const { options, onSelect, selectValue, valueArray } = props

  return options.map((option: any, index: any) => {
    const isCurrentOptionSelected = isOptionSelected(option, valueArray)
    return (
      <div key={ `menu--item-select-${ index }` }>
        <div
          onKeyDown={ () => {
          } }
          onClick={ () => {
            if (isOptionSelected(option, valueArray)) {
              selectValue(option)
            } else if (option.suboptions) {
              selectValue([option, ...option.suboptions.filter((item: any) => !isOptionSelected(item, valueArray))])
            } else {
              selectValue(option)
            }
          } }
          role="button"
          tabIndex={ index }
          className={ classnames({
            option: true,
            selectedOptionBackground: isCurrentOptionSelected,
            sites: true,
          }) }
        >
          <div className="titleWrapper">
            <div className="label">
              { option.label }
            </div>
            <div className="sublabel">
              { option.sublabel }
            </div>
          </div>
        </div>
        { !option.suboptions ? (null) : (
          option.suboptions.map((suboption: any, subIndex: any) => {
            const isAllSuboptionsSelected = isOptionSelected(suboption, valueArray)
            return (
              <div
                key={ `menu--subitem-select-${ index }-${ subIndex }` }
                onKeyDown={ () => {
                } }
                onClick={ () => {
                  onSelect(suboption)
                } }
                role="button"
                tabIndex={ index }
                className={ classnames('option', 'suboptionWrapper') }
              >
                <div
                  className={ classnames({
                    itemIcon: true,
                    selectedOption: isAllSuboptionsSelected,
                  }) }
                />
                <div className="titleWrapper">
                  <div className="label">
                    { option.label }
                    { ' ' }
                    -
                    { ' ' }
                    { suboption.label }
                  </div>
                  <div className="sublabel">
                    { suboption.sublabel }
                  </div>
                </div>
              </div>
            )
          })
        ) }
      </div>
    )
  })
}

export const SelectAutocomplite = (props: any) => {
  const { onChange, value, isMulti, small, filledTriangle, valid, label, disabled, onKeyPress } = props

  return (
    <div className={ classnames(
      'select',
      !props.options && 'select__hide',
      small ? 'small' : null,
      filledTriangle ? 'filledTriangle' : null,
      !valid ? 'error' : null,
      !isMulti ? 'valueWithoutBackground' : null,
      !isMulti ? 'lowerOptions' : 'upperOptions',
      disabled && 'isDisabled',
    ) }
    >
      <div className="label">
        { label }
      </div>
      <Select
        name={props.input && props.input.name}
        classNamePrefix="select"
        isDisabled={ disabled || false }
        isRtl={ false }
        onKeyDown={onKeyPress}
        isClearable={ isMulti || false }
        isSearchable={ !false }
        menuRenderer={ menuComponent }
        isMulti={ isMulti ? true : false }
        onBlur={() => {}}
        onChange={(val: any) => onChange(val)}
        value={ value }
        { ...props.input }
        { ...props }
      />
    </div>
  )
}
